import { menuEntryClickedAction } from '../../../../appchrome';
import { buildReducer, DeletedItemsSubViewType, isConsumer } from '../../../../shared';
import type { DeletedItemsFolderState } from '../../../state/deletedItemsFolderState';
import { deletedItemsSubViewToggleClickedAction } from '../../../actions/user/deletedItems/deletedItemsActions';

const defaultItemsSubViewType = isConsumer()
    ? DeletedItemsSubViewType.RecoverableContactsFolder
    : DeletedItemsSubViewType.DeletedContactsFolder;

export const defaultState: DeletedItemsFolderState = {
    deletedItemsSubViewType: defaultItemsSubViewType,
};

export default buildReducer<DeletedItemsFolderState>()
    .handle(deletedItemsSubViewToggleClickedAction, (state, action) => {
        return {
            deletedItemsSubViewType:
                state.deletedItemsSubViewType === DeletedItemsSubViewType.DeletedContactsFolder
                    ? DeletedItemsSubViewType.RecoverableContactsFolder
                    : DeletedItemsSubViewType.DeletedContactsFolder,
        };
    })
    .handle(menuEntryClickedAction, (state, action) => {
        return {
            deletedItemsSubViewType: defaultItemsSubViewType,
        };
    })
    .done(defaultState);
export type { Action } from '../../../../shared';
